import { HelpRounded, TranslateRounded } from '@mui/icons-material'
import { FormControl, Tooltip } from '@mui/material'
import { ThemeProvider as ThemeProviderV5 } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation } from 'react-router'
import { getLanguages } from '../../../../redux/actions/languages'
import { getCurrentCommits } from '../../../../redux/actions/log'
import { IRootState } from '../../../../redux/types'
import HiddenMobile from '../../styles/HiddenMobile'
import { BoxLanguage, ButtonHelp, ItemOptionLanguage, SelectLanguage } from '../../styles/LoginRegisterStyle'
import { mainThemeV5 } from '../../styles/themes/NavLayoutTheme'
import Footer from './Footer'

function NavLayout() {
  const { t } = useTranslation(['global'])
  const { i18n } = useTranslation()
  const location = useLocation()

  const dispatch = useDispatch()
  const { languages } = useSelector((state: IRootState) => state.language)

  const [globalLanguage, setGlobalLanguage] = useState('1')

  useEffect(() => {
    dispatch(getLanguages())
    dispatch(getCurrentCommits())
  }, [])

  const handleGlobalLanguage = (language_id: number, language_code: string) => {
    localStorage.setItem('globalLanguageId', language_id.toString())
    localStorage.setItem('globalLanguageCode', language_code)
    setGlobalLanguage(language_id.toString())
    i18n.changeLanguage(language_code)
  }

  let isWhite =
    location.pathname.includes('/iniciar-sesion') ||
    location.pathname.includes('/registro') ||
    location.pathname.includes('/recordar-contrasena') ||
    location.pathname.includes('/asignar-contrasena') ||
    location.pathname === '/'

  return (
    <ThemeProviderV5 theme={mainThemeV5}>
      <BoxLanguage display="flex">
        {import.meta.env.VITE_NAME === 'PLEI' && (
          <HiddenMobile>
            <Tooltip title={`${t('help')}`}>
              <ButtonHelp href="https://plei.drv.es/preguntas-frecuentes/">
                <HelpRounded color="primary" />
              </ButtonHelp>
            </Tooltip>
          </HiddenMobile>
        )}
        <FormControl>
          <SelectLanguage labelId="languages" id="login-languages" value={globalLanguage} className={isWhite ? '' : 'dark'}>
            {languages.map((language: any) => (
              <ItemOptionLanguage key={language.id} onClick={() => handleGlobalLanguage(language.id, language.code)} value={language.id}>
                <TranslateRounded
                  sx={theme => ({
                    [theme.breakpoints.down('sm')]: {
                      display: 'none'
                    }
                  })}
                />
                {language.name}
              </ItemOptionLanguage>
            ))}
          </SelectLanguage>
        </FormControl>
      </BoxLanguage>
      <Outlet />
      <Footer dark={!isWhite} />
    </ThemeProviderV5>
  )
}

export default NavLayout
